<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-03-25 14:29:15
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-09-27 15:35:47
 * @FilePath: \lightning\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-03-25 14:29:15
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-06-06 18:47:06
 * @FilePath: \lightning\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <div class="headerBox">
      <div class="logoBox">LLWP 松江区雷电监测预警平台</div>
      <div class="pageChooseBox">
        <div class="pageItem active" data-index="index" @click="chooseTab">雷电外推</div>
        <div class="pageItem" data-index="warning" @click="chooseTab">雷电预警</div>
        <div class="pageItem" data-index="inspection" @click="chooseTab">雷电检验</div>
        <div class="pageItem"  data-index="set" @click="chooseTab">系统管理</div>
        <!-- <div class="pageItem" @click="chooseTab">闪电定位</div>
        <div class="pageItem" @click="chooseTab">预警发布</div>
        <div class="pageItem" @click="chooseTab">产品与外推</div>-->
      </div>
    </div>
    <div class="mainviewBox">
      <router-view style="width:100%;height:100%;"></router-view>
    </div>
  </div>
</template>
<script>
// import axios from "axios";
export default {
  data() {
    return {
      data: []
    };
  },
  created() {},
  methods: {
    chooseTab(e) {
      console.log(e.target.dataset.index);
      if (e.target.dataset.index == "index") {
        this.$router.push("/");
      } else if (e.target.dataset.index == "warning") {
        this.$router.push("/warning");
      } else if (e.target.dataset.index == "inspection") {
        this.$router.push("/inspection");
      }else if (e.target.dataset.index == "set") {
        this.$router.push("/set");
      }
      let ELList = document.querySelectorAll(".pageItem");
      ELList.forEach(item => {
        item.classList.remove("active");
      });
      // console.log(e.target);
      e.target.classList.add("active");
    }
  }
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
#app {
  height: 100vh;
  width: 100vw;
  /* background-color: aqua; */
}
.headerBox {
  height: 60px;
  width: 100%;
  background: linear-gradient(135deg, #001f3f 25%, #001a33 75%);
  border-bottom: 2px solid #005f9f;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
  /* display: flex;
            align-items: center; */
  padding: 0 20px;
  position: relative;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
}
.headerBox::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, #005f9f, #00c8ff);
  box-shadow: 0 0 10px #00c8ff, 0 0 20px #00c8ff, 0 0 30px #00c8ff;
}
.logoBox {
  height: 100%;
  /* width: 300px; */
  font-size: 24px;
  color: #ffffff;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 60px;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
}
.pageChooseBox {
  height: 100%;
  width: 600px;
  /* background-color: aqua; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.pageItem {
  height: 100%;
  width: 100px;

  color: white;
  text-align: center;
  line-height: 60px;
}
.pageItem.active {
  /* background-color: #0065b1; */
  color: #00c8ff;
  text-shadow: 0 0 10px #00c8ff, 0 0 20px #00c8ff, 0 0 30px #00c8ff,
    0 0 40px #00c8ff;
  font-size: 20px;
}
.my-layer-item {
  position: relative;
  /* position: absolute;
  bottom: 0; */
  /* background: #666;
  color: #fff; */
  width: 80px;
  text-align: center;
  z-index: 1;
}
/* .my-layer-item {
  color: red;
  position: absolute;
  bottom: 10px;
  z-index: 9;
} */
/* .my-layer-img {
  position: relative;
  z-index: 999;
} */
.mainviewBox {
  height: calc(100vh - 60px);
  width: 100vw;
  /* background-color: aqua; */
}
/* ::-webkit-scrollbar {
  width: 15px;
  height: 8px;
  background-color: #ebeef5;
}
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #02203c;
  border-radius: 7px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background-color: #011f3dcb;
} */
</style>
